import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initGA, usePageviewTracking } from "./utils/analytics";
import Homepage from "./pages/gd_sg/Homepage";
import Header from "./pages/gd_sg/Header";
import Footer from "./pages/gd_sg/Footer";
import ListingPage from "./pages/gd_sg/ListingPage";
import ShowPage from "./pages/gd_sg/ShowPage";
import MiceAboutPage from "./pages/gd/MiceAboutPage";
import MiceAgentRegistrationPage from "./pages/gd/MiceAgentRegistrationPage";
import MiceEnquiryPage from "./pages/gd/MiceEnquiryPage";
import NewsAndBlogsPage from "./pages/gd_sg/NewsAndBlogsPage";
import NewsAndBlogsShowPage from "./pages/gd/NewsAndBlogsShowPage";
import GalleryPage from "./pages/gd/GalleryPage";
import GalleryShowPage from "./pages/gd/GalleryShowPage";
import PartnerSignInPage from "./pages/gd/PartnerSignInPage";
import AboutUsPage from "./pages/gd_sg/AboutUsPage";
import ContactUsPage from "./pages/gd/ContactUsPage";
import ContactAgentsPage from "./pages/gd_sg/ContactAgentsPage";
import GDFlightContactAgentsPage from "./pages/gd/GDFlightContactAgentsPage";
import WhatsNewPage from "./pages/gd/WhatsNewPage";
import WhatsNewShowPage from "./pages/gd/WhatsNewShowPage";
import SeriesPage from "./pages/gd_sg/SeriesPage";
import SeriesShowPage from "./pages/gd_sg/SeriesShowPage";
import FooterStaticPage from "./pages/gd/FooterStaticPage";
import ScrollToTop from "./layouts/ScrollToTop";
import IceVisaContactAgentsPage from "./pages/gd/IceVisaContactAgentsPage";
import PostShowPage from "./pages/gd/PostShowPage";
import ResetPasswordPage from "./pages/gd/ResetPasswordPage";
import PostsPage from "./pages/gd/PostsPage";
import PostsShowPage from "./pages/gd/PostsShowPage";
import SignInPage from "./pages/gd/SignInPage";
import MainLayout from "./layouts/gd/MainLayout";
import FloatingChatButton from "./layouts/FloatingChatButton";

const layout = <MainLayout Header={<Header/>} Footer={<Footer/>}/>;

function Inner(){
  const location = useLocation()

  usePageviewTracking();

  useEffect(() => {
    // Scroll to the element with the ID from the fragment identifier
    if (location.hash) {
      const element = document.querySelector(location.hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
        window.history.replaceState("", document.title, location.pathname);
      }
    }
  }, [location.hash])

  return (
    <Routes>
      <Route path="/web" element={layout}>
      <Route index element={<Homepage />} />
        <Route path="/web/listing" element={<ListingPage />} />
        <Route path="/web/itinerary/:id" element={<ShowPage />} />
        <Route path="/web/series-tour/:type" element={<SeriesPage />} />
        <Route path="/web/series-tour/:type/:id" element={<SeriesShowPage />} /> 
        <Route path="/web/posts/:type" element={<PostsPage />} />
        <Route path="/web/posts/:type/:id" element={<PostsShowPage />} />
        <Route path="/web/mice/about" element={<MiceAboutPage />} />
        <Route path="/web/mice/agent-registration" element={<MiceAgentRegistrationPage />} />
        <Route path="/web/mice/enquiry" element={<MiceEnquiryPage />} />
        <Route path="/web/post/:type" element={<PostShowPage />} />
        <Route path="/web/ice-visa-services-agents" element={<IceVisaContactAgentsPage />} />
        <Route path="/web/blogs" element={<NewsAndBlogsPage />} />
        <Route path="/web/blogs/:id" element={<NewsAndBlogsShowPage />} />
        <Route path="/web/gallery" element={<GalleryPage />} />
        <Route path="/web/gallery/:id" element={<GalleryShowPage />} />
        <Route path="/web/new-posts" element={<WhatsNewPage />} />
        <Route path="/web/new-posts/:id" element={<WhatsNewShowPage />} />
        
        <Route path="/web/partner-sign-in" element={<PartnerSignInPage />} />
        <Route path="/web/about-us" element={<AboutUsPage />} />
        <Route path="/web/contact-us" element={<ContactUsPage />} />
        <Route path="/web/contact-agents" element={<ContactAgentsPage />} />
        <Route path="/web/gd-flight-agents" element={<GDFlightContactAgentsPage />} />

        <Route path="/web/footer/:type" element={<FooterStaticPage />} />
        <Route path="/web/reset-password" element={<ResetPasswordPage />} />
        <Route path="/web/sign-in" element={<SignInPage />} />
      </Route>
    </Routes>
  )

}


export default function gd_sg(props: {isUserSignedIn:boolean, username: string, google_tracking_id?: string}) {
  initGA(props.google_tracking_id);
  return (
    <BrowserRouter>
      <ScrollToTop/>
      <FloatingChatButton />
      <Inner/>
    </BrowserRouter>
  );
}